import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getGraphQLClient } from '@/common/graphqlClient';
import { QueryKeys } from '@/common/queryKeys';
import { graphql } from '@/generated/graphql';

const GET_COUNTRY_HOLIDAYS = graphql(`
  query GetCountryList {
    country {
      id
      name
      country_holidays {
        date
        id
      }
    }
  }
`);

const INSERT_COUNTRY_HOLIDAY = graphql(`
  mutation InsertCountryHoliday($countryId: String!, $date: timestamptz!) {
    insert_country_holiday_one(object: { countryId: $countryId, date: $date }) {
      id
    }
  }
`);

const DELETE_COUNTRY_HOLIDAY = graphql(`
  mutation DeleteCountryHoliday($id: Int!) {
    delete_country_holiday_by_pk(id: $id) {
      id
    }
  }
`);

export const useGetCountryHolidays = () => {
  const client = getGraphQLClient();
  return useQuery({
    queryKey: [QueryKeys.GET_COUNTRY_HOLIDAYS],
    queryFn: () => client.request(GET_COUNTRY_HOLIDAYS),
  });
};

export const useInsertCountryHoliday = () => {
  const client = getGraphQLClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (variables: { countryId: string; date: string }) =>
      client.request(INSERT_COUNTRY_HOLIDAY, variables),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [QueryKeys.GET_COUNTRY_HOLIDAYS] });
    },
  });
};

export const useDeleteCountryHoliday = () => {
  const client = getGraphQLClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (variables: { id: number }) => client.request(DELETE_COUNTRY_HOLIDAY, variables),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [QueryKeys.GET_COUNTRY_HOLIDAYS] });
    },
  });
};
